// Helper function to format due date display
export function formatDueDate(daysUntilDue: number): string {
  if (daysUntilDue === 0) return 'Due today';
  if (daysUntilDue === 1) return 'Due in 1 day';
  if (daysUntilDue <= 6) return `Due in ${daysUntilDue} days`;
  if (daysUntilDue === 7) return 'Due in 1 week';
  if (daysUntilDue <= 13) return `Due in ${Math.ceil(daysUntilDue / 7)} weeks`;
  return `Due in ${Math.ceil(daysUntilDue / 7)} weeks`;
}